// TODO @cleanup merge this with the shit in donation/....
import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style.js";
import {Flow} from "../initializeFlows.js";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {Messages} from "../../Messages.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {DonationStore} from "../../../client/state/DonationStore.js";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {UsingCardComponent} from "../pages/panels/payment-method/components/UsingCardComponent.jsx";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";
import {Controller} from "../Controller.js";
import {EditDonationComponent} from "../pages/panels/donation/edit-donation/EditDonationPanel.jsx";


export class DonateHomeEditDonationComponent extends EditDonationComponent {
    updateDonation() {
        Flow.donation.inlineUpdateDonation(this.options.changeURL);
    }
}


class EditDonationPanelStyle extends StyleSheet {
    @styleRule
    title = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        fontSize: 24,
        marginBottom: 20,
    };

    @styleRule
    description = {
        display: "inline",
    };

    @styleRule
    inlineLink = {
        ...this.themeProps.PANEL_LINK,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        display: "inline-block",
        marginBottom: 20,
    };

    @styleRule
    back = this.themeProps.PANEL_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends UI.Element {
    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(Flow.donation.isValid()
            && (Flow.donation.donationAmount !== donation.computeAmount()
                || Flow.donation.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== Controller.paymentMethod.selectedPaymentMethod));
    }

    updateDonation() {
        LoadingSpinner.show();
        this.editDonationComponent.updateDonation();
    }

    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;

        return [
            <div className={styleSheet.title}>{Messages.editDonationInlineTitle}</div>,
            <div>
                <MessageElement className={styleSheet.description}
                                message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}/>
                <Link value={Messages.here} className={styleSheet.inlineLink}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.cancelDonation)}/>.
            </div>,
            <UsingCardComponent card={Controller.paymentMethod.selectedPaymentMethod} hideTitle={true}
                                onChangeCard={() => this.options.changeURL(DONATE_PAGE_URLS.editChooseCard, true)}
                                changeCardMessage={Messages.edit} />,
            <DonateHomeEditDonationComponent
                ref="editDonationComponent"
                changeURL={this.options.changeURL}
                onChange={() => this.redraw()}/>,
            <MerchantButton label={Flow.donation.getDonatePageEditDonationComponentButtonLabel()}
                            disabled={this.isButtonDisabled()} onClick={() => this.updateDonation()}
                            ref="button"/>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.recurringDonor, true)}/>
            </div>,
            <PoweredByBlink className={styleSheet.blinkLogo}/>,
        ];
    }

    onMount() {
        this.redraw(); // We need this first redraw because we have interdependent components
        this.attachChangeListener(PaymentMethodStore, () => {
            if (this.isInDocument()) {
                this.redraw()
            }
        });
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument()) {
                if (!iFrameUserDataService.getActiveRecurringDonation()) {
                    this.options.changeURL(DONATE_PAGE_URLS.donate, true);
                } else {
                    this.redraw();
                }
            }
        });
    }
}
